export const state = () => ({
    sendQuestNotificationMessage: "",
    sendQuestNotificationType: "",
    sendQuestNotificationParams: null,
  
    isOpenSendQuestNotification: false,
  })
  
  export const mutations = {
    openSendQuestNotification: function (state, {
      message,
      params
    }) {
      state.sendQuestNotificationMessage = message;
      state.isOpenSendQuestNotification = true;
      state.sendQuestNotificationType = params?.type || "";
      state.sendQuestNotificationParams = params || null;
    },
    closeSendQuestNotification: function (state) {
      state.isOpenSendQuestNotification = false;
    },
  }
  